import React, { Fragment, useContext, useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../../../AbstractElements';
import EmailContext from '../../../../_helper/Email';
import Email from './Email';
import MailSidebar from './MailSidebar';

const MailInboxContain = () => {  

  const { allEmails, types, setType, type, getAllType, groupBy, setCompose } = useContext(EmailContext);
  const TypesOfData = types;

  useEffect(() => {
    if (allEmails !== null) {
      const result = groupBy(allEmails, (item) => {
        return [item.type];
      });
      getAllType(result);
    }
  }, [allEmails]);


  let pinagareApplications =  [ {
        "id": 1,
        "image": "user/9.jpg",
        "name": "Leadership Transformation Programme",
        "email": "pork@company.com",
        "date": "15 Feb 2024",
        "cc": "Application submitted on 15 Feb 2024.,",
        "type": "Programmes",
        "text": "<p>Hello</p><p>Dear Sir Good Morning,</p><h5>Elementum varius nisi </h5><p class='m-b-20'> sapien vel hendrerit</p>",
        "favourite": false
      }]
      

  return (
    <Fragment>
      <Breadcrumbs mainTitle='My Applications' parent='Home' title='My Applications' />
      <Container fluid={true}>
        <div className='email-wrap'>
          <Row>
            <Email />
            <MailSidebar  />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};
export default MailInboxContain;
